module.exports = __webpack_public_path__ + "static/img/cudos.c725866.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/cudos.svg
// module id = 46q0
// module chunks = 1